<template>
  <div>
  
  <el-dialog :title="categoryTitle" :visible.sync="showCategory" width="35%" :close-on-click-modal=false :before-close="handleDialogClose">
    <el-form ref="formData" :model="formData" label-width="100px" :rules="rules" class="demo-ruleForm">
      <el-form-item label="上级分类：" prop="parentName">
        <el-input v-model="formData.parentName"  placeholder="上级分类" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="分类名称：" prop="ccName">
        <el-input v-model="formData.ccName"  placeholder="分类名称"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleDialogClose">取 消</el-button>
      <el-button type="primary" @click="saveCategory('formData')">确 定</el-button>
    </div>
  </el-dialog>
  <dragTreeTable :data="treeData" ref="dragCategory" :onDrag="onTreeDataChange" :isdraggable="false" :OpenAll="true"/>
  </div>
</template>


<script>
  import https from '@/https.js'
  import dragTreeTable from 'drag-tree-table'
  
  const formData = {
    ccId: "",
    ccName:"",
    parentId:"0",
    ccSort: "",
    parentName: "",
    classLayer: "",
    level: 1,
  };
  export default {
    data() {
      const data = [];

      return {
        showTree: true,
        treeData: [],
        top: false,
        showCategory:false,
        loading: false,
        categoryTitle: "添加分类",
        formData: JSON.parse(JSON.stringify(formData)),
        defaultProps: {
          children: 'children',
          label: 'ccName'
        },
        treeData: {
          lists: [],
          custom_field: {
            id: 'ccId',
            order: 'ccSort',
            lists: 'children',
            parent_id: 'parentId',
          },
          columns: [
            {
              type: 'selection',
              title: '分类名称',
              field: 'ccName',
              width: 600,
              align: 'left',
              
            },
            {
              title: '操作',
              type: 'action',
              width: 350,
              align: 'left',
              actions: [
                {
                  text: '添加',
                  onclick: this.addCategory,
                  formatter: (item) => {
                    if(item.level == 1) {
                      return '<i style="margin-right: 10px">添加</i>'
                    }
                  }
                }, {
                  text: '编辑',
                  onclick: this.updateCategory,
                  formatter: (item) => {
                    return '<i style="margin-right: 10px" >编辑</i>'
                  }
                },{
                  text: '上移',
                  onclick: this.upCategory,
                  formatter: (item) => {
                    return '<i style="margin-right: 10px">上移</i>'
                  }
                },{
                  text: '下移',
                  onclick: this.downCategory,
                  formatter: (item) => {
                    return '<i >下移</i>'
                  }
                }
              ]
            },
          ]
        },
        rules: {
          ccName: [
            { required: true, message: '请填写分类名称', trigger: 'blur' },
            {  max: 20, message: '长度不得超过 20 个字符', trigger: 'blur' }
          ]
        },
      }
    },

    methods: {
      onTreeDataChange(lists) {
        this.treeData.lists = lists
      },
      handleDialogClose() {
        this.showCategory = false;
        this.formData.ccId = "";
        this.categoryTitle = "添加分类"
        this.formData = JSON.parse(JSON.stringify(formData));
        this.$refs.formData.clearValidate();
      },

      search() {
        this.loading = true;
        let params = {};
        https.fetchGet('/courseCategoryInfo/selectListRecursion',params, "from" ).then((data) => {
          let code = data.data.code;
          if(code == 200) {
            this.loading = false;
            this.treeData.lists = data.data.data
            this.$refs.dragCategory.OpenAll();
          } else {
            this.loading = false;
            this.$message({
              type: 'info',
              message: '加载失败'+msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
              this.loading = false;
            }
        )
      },
      addCategory( row) {
        this.showCategory = true;
        let parentName = "";
        let classLayer = "1";
        let parentId = "0";
        let level = 1;
        if(row) {
          let _row = JSON.parse(JSON.stringify(row));
          parentId = _row.ccId;
          parentName = _row.ccName;
          classLayer = _row.classLayer+1;
          level = _row.level+1;
        }
        this.formData.parentId = parentId;
        this.formData.parentName = parentName;
        this.formData.classLayer = classLayer;
        this.formData.level = level;
      },
      updateCategory(row) {
        this.categoryTitle = "修改分类";
        this.showCategory = true;
        this.formData = JSON.parse(JSON.stringify(row));
      },
      saveCategory(formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          }else {
            let params = this.formData;
            let url = "/courseCategoryInfo/insertByParentId";
            console.log(this.formData.permissionId);
            if(this.formData.ccId != "") {
              url = "/courseCategoryInfo/updateNameByCcId";
            }
            https.fetchPost(url,params ,"json").then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if(code == '200') {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.showCategory = false;
                this.formData = JSON.parse(JSON.stringify(formData));
                this.search();
              } else {
                this.$message.error('操作失败:'+msg);
              }

            }).catch(err=>{
                  console.log(err);
                  this.$message.error('网络错误');
                }
            )
          }
        });
      },
      upCategory(row) {
        let params = row;
        https.fetchPost('/courseCategoryInfo/updateUpSort',params, "json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              type: 'info',
              message: '操作失败:'+msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
              this.loading = false;
            }
        )
      },
      downCategory(row) {
        let params = row;
        https.fetchPost('/courseCategoryInfo/updateDownSort',params, "json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.search();
          } else {
            this.$message({
              type: 'info',
              message: '操作失败:'+msg
            });
          }

        }).catch(err=>{
              this.$message.error('网络错误');
              this.loading = false;
            }
        )
      },
    },
    created: function () {
      this.search();
      
    }
  };
</script>

<style scoped>

</style>